<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planType: 101 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planType: 101, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, planType: 101 }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <global-select
                v-decorator="['supplierIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="supplierName"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码">
              <global-select
                v-decorator="['itemIdList']"
                selectType="selectMultipleSearch"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode || organizationCodeOrigin }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料类别">
              <a-tree-select
                v-decorator="['categoryIdList']"
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="状态">
              <global-select
                v-decorator="['statusList']"
                selectType="selectMultiple"
                requestApi="/system/lookup/data/list"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_PR_SUPPLIER_REPLY_STATUS' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="显示">
              <global-select
                v-decorator="['lineTypeList']"
                selectType="selectMultiple"
                :selectData="lineTypeListData"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24" class="aj-center-between">
            <a-form-item label="快捷过滤">
              <a-button v-for="item in searchList1" :key="item.id" type="link" @click="handleMenuClick(item)">{{ item.schemeName }}</a-button>
              <a-dropdown v-if="searchList2.length > 0">
                <a-menu slot="overlay">
                  <a-menu-item v-for="item in searchList2" :key="item.id" @click="handleMenuClick(item)">{{ item.schemeName }}</a-menu-item>
                </a-menu>
                <a-button type="link">更多<a-icon type="down" /> </a-button>
              </a-dropdown>
              <a-button @click="$refs.dressingByScreening.show(form.getFieldsValue())">保存筛选方案</a-button>
            </a-form-item>
            <span class="table-page-search-submitButtons">
              <a-button @click="$refs.dressingByScreeningSetUp.show()">设置筛选方案</a-button>
              <a-button @click="onSearch" type="primary" class="ml8">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-form layout="inline" :labelCol="{ style: { width: '120px' } }">
          <a-row class="align-center">
            <a-button @click="handleExport" v-hasPermi="['scp:scpMrpHorizontalSummary:supplierReserveExport']">导出</a-button>
            <a-button class="ml10" @click="importExcelHandleOpen">导入并发布</a-button>
            <!-- 上传文件 -->
            <a-modal
              :title="upload.title"
              :visible="excelVisible"
              @ok="importExcelHandleCancel"
              @cancel="importExcelHandleCancel"
            >
              <a-upload-dragger
                name="file"
                accept=".xlsx, .xls"
                :multiple="true"
                :headers="upload.headers"
                :action="`${upload.url}?updateSupport=${upload.updateSupport}&planVersion=${form.getFieldsValue().planVersion || ''}`"
                @change="importExcelHandleChange"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                  请将文件拖拽到此处上传
                </p>
                <p class="ant-upload-hint">
                  支持单个或批量上传，也可以点击后选择文件上传
                </p>
              </a-upload-dragger>
            </a-modal>
            <a-col :md="7" :sm="24" class="ml50">
              <a-form-item label="数据收集时间">
                <a-input v-model="dataCollectStartDate" disabled />
              </a-form-item>
            </a-col>
            <a-col :md="7" :sm="24">
              <a-form-item label="计划运算完成时间">
                <a-input v-model="planCompletionDate" disabled />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="serialNumber"
          :scroll="{ x: tableX, fixScreen: true }"
          @successCallBack="successCallBack"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="(!isEdit || currentId !== record.serialNumber) && record.prStatus === 'PENDING_RESPONSE' && editStatusList.includes(record.status) && record.lineType === 'ASSIGN_QTY'" @click="handleEdit(record)" v-hasPermi="['scp:scpMrpHorizontalSummary:supplierReserveEdit']">编辑</a>
                <a v-if="(!isEdit || currentId !== record.serialNumber) && record.prStatus === 'PENDING_RESPONSE' && record.lineType === 'ASSIGN_QTY'" @click="handleRecall(record)" class="ml10" v-hasPermi="['scp:scpMrpHorizontalSummary:supplierReserveWithdra']">撤回</a>
                <a v-if="isEdit && currentId === record.serialNumber" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.serialNumber" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.serialNumber">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.serialNumber" v-model="record[item.dataIndex]" :min="0" size="small" />
              </span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex)) && Number(text) < 0" :class="['color-red', {'line-ellipsis':item.ellipsis}]" :title="item.ellipsis ? text : ''">{{ text }}</span>
              <span v-else-if="(record.boss || columnsAdd.includes(item.dataIndex))" :class="{ 'line-ellipsis': item.ellipsis }" :title="item.ellipsis ? text : ''">{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <dressing-by-screening-set-up ref="dressingByScreeningSetUp" @handle-success="handleOk" />
        <dressing-by-screening ref="dressingByScreening" @handle-success="handleOk2" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpMrpHorizontalSummarySupplierReservePlanList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpScreeningSchemeSearchAllScheme,
  apiScpMrpPlansCallMaterialPlanExecutionTime,
  apiScpMrpHorizontalDatesDateDisplayList,
  apiScpMrpHorizontalSummarySupplierReserveWithdraw,
  apiScpMrpHorizontalSummarySupplierReserveEdit
} from '@/api/scp/reserve-goods-plan/supplier-reserve-plan'
import DressingByScreening from '@/components/DressingByScreening/index'
import DressingByScreeningSetUp from '@/components/DressingByScreeningSetUp/index'
import { generateLsTableResData } from '@/utils/util.js';
import Cookies from 'js-cookie';
export default {
  // eslint-disable-next-line
  name: 'Supplier-reserve-plan', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DressingByScreening,
    DressingByScreeningSetUp
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      isEdit: false,
      currentId: "",
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpHorizontalSummarySupplierReservePlanList, true),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpMrpHorizontalSummary/supplierReserveImport'
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 控制搜索展开
      advanced: true,
      // 表格数据
      tableX: 2500,
      tableList: [],
      // 表格字段
      columnsOrigin: [],
      columnsAdd: [],
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          scopedSlots: { customRender: 'organizationName' },
          align: 'center',
          width: 120,
          fixed: 'left'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          scopedSlots: { customRender: 'itemCode' },
          align: 'center',
          width: 120,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'uom',
          scopedSlots: { customRender: 'uom' },
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          scopedSlots: { customRender: 'itemName' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          scopedSlots: { customRender: 'specification' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          scopedSlots: { customRender: 'name1' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          scopedSlots: { customRender: 'name2' },
          align: 'center',
          ellipsis: true
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          scopedSlots: { customRender: 'name3' },
          align: 'center',
          ellipsis: true
        },
        {
          title: 'MPQ',
          dataIndex: 'fixedLotMultiplier',
          scopedSlots: { customRender: 'fixedLotMultiplier' },
          align: 'center'
        },

        {
          title: '备库L/T',
          dataIndex: 'safetyStockLeadTime',
          scopedSlots: { customRender: 'safetyStockLeadTime' },
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'statusName',
          scopedSlots: { customRender: 'statusName' },
          align: 'center'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          scopedSlots: { customRender: 'supplierName' },
          align: 'center'
        },
        {
          title: '修改原因',
          dataIndex: 'supplierComments',
          scopedSlots: { customRender: 'supplierComments' },
          align: 'center',
          ellipsis: true
        },
        {
          title: 'prpo在途数量',
          dataIndex: 'prPoSummary',
          scopedSlots: { customRender: 'prPoSummary' },
          width: 140,
          align: 'center',
          ellipsis: true
        },
        {
          title: 'MOQ处理',
          dataIndex: 'moqTypeName',
          scopedSlots: { customRender: 'moqTypeName' },
          align: 'center'
        },
        {
          title: 'MOQ',
          dataIndex: 'moq',
          scopedSlots: { customRender: 'moq' },
          align: 'center'
        },
        {
          title: '数据类型',
          dataIndex: 'lineTypeName',
          scopedSlots: { customRender: 'lineTypeName' },
          align: 'center'
        },
        {
          title: '总数量',
          dataIndex: 'summary',
          scopedSlots: { customRender: 'summary' },
          align: 'center'
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          scopedSlots: { customRender: 'planName' },
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          scopedSlots: { customRender: 'planVersion' },
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right'
        }
      ],
      lineTypeListData: [], // 显示
      searchList1: [],
      searchList2: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      treeData: [], // 物料类别
      dataCollectStartDate: "", // 数据收集时间
      planCompletionDate: "", // 计划运算完成时间
      editStatusList: ["SUPPLIER_REJECT", "APPROVED", "RECALL"], // 待复核、已确认、已撤回
      excelVisible: false
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.form.setFieldsValue({
      organizationCode: this.organizationCodeOrigin
    })
    this.columnsOrigin = JSON.parse(JSON.stringify(this.columns))
    this.getLookupList('SCP_MRP_LINE_TYPE_PR_VENDOR', 'lineTypeListData')
    this.getCategoryIdList(true)
    this.getSearchAllScheme()
  },
  mounted () {},
  methods: {
    // 撤回
    handleRecall (record) {
      apiScpMrpHorizontalSummarySupplierReserveWithdraw(record.id).then(response => {
        if (response.code === 200) {
          this.$message.success('撤回成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.serialNumber !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.columns = JSON.parse(JSON.stringify(this.columns))
      this.isEdit = true;
      this.currentId = record.serialNumber;
    },
    // 编辑-保存
    handleSave (record) {
      const obj = JSON.parse(JSON.stringify(record))
      const arr = []
      for (const item in obj) {
        if (item.substring(0, 4).indexOf("date") >= 0) {
          arr.push(obj[item])
        }
      }

      const params = {
        quantitiesId: record.quantitiesId,
        dataList: arr,
        id: record.id
      }
      apiScpMrpHorizontalSummarySupplierReserveEdit(params).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
     this.onSearch()
     this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.getCategoryIdList()
    },
    handleOk2 () {
      this.getCategoryIdList()
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      this.isEdit = false
      this.getTableTime()
      this.lineTypeListChange(this.form.getFieldsValue().lineTypeList)
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    successCallBack (myDataSource) {
      const tableList = JSON.parse(JSON.stringify(myDataSource))
      const arr2 = tableList.map(item => item.id)
      const arr3 = Array.from(new Set(arr2))
      const arr4 = []
      for (let i = 0; i < tableList.length; i++) {
        for (let j = 0; j < arr3.length; j++) {
          if (tableList[i].id === arr3[j] && !arr4.includes(arr3[j])) {
            arr4.push(arr3[j])
            tableList[i].boss = true
          }
        }
      }
      this.$refs.dataTable.myDataSource = tableList
      this.tableList = tableList
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    // 快捷过滤
    handleMenuClick (val) {
      this.form.setFieldsValue(JSON.parse(val.schemeDetailJson))
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.tableList = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpHorizontalSummary/supplierReservePlanExport', {
        ...this.form.getFieldsValue()
      }, `分供应商储备计划_${new Date().getTime()}.xlsx`)
    },
    // 物料类别-下拉框数据
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    },
    // 快捷过滤数据
    getCategoryIdList (flag) {
      apiScpScreeningSchemeSearchAllScheme({ menuId: this.$route.meta.menuId }).then(res => {
        if (res.data && res.data.length > 0) {
          const arr = []
          const arr2 = []

          res.data.forEach((element, index) => {
            if (index < 3) {
              arr.push(element)
            } else {
              arr2.push(element)
            }
            if (flag && element.defaultFlag === "Y") {
              this.form.setFieldsValue(JSON.parse(element.schemeDetailJson))
              this.onSearch()
            }
          });
          this.searchList1 = arr
          this.searchList2 = arr2
        } else {
          this.searchList1 = []
          this.searchList2 = []
        }
      })
    },
    getTableTime () {
      // 数据收集时间、计划运算完成时间
      apiScpMrpPlansCallMaterialPlanExecutionTime(this.form.getFieldsValue()).then(res => {
        if (res.data) {
          this.dataCollectStartDate = this.$moment(res.data.dataCollectStartDate).format('YYYY-MM-DD HH:mm:ss')
          this.planCompletionDate = this.$moment(res.data.planCompletionDate).format('YYYY-MM-DD HH:mm:ss')
        }
      })
      // 动态表头
      apiScpMrpHorizontalDatesDateDisplayList({ planVersion: this.form.getFieldsValue().planVersion, dataType: "CALL" }).then(res => {
        if (res.data && res.data.length > 0) {
          const columns = JSON.parse(JSON.stringify(this.columnsOrigin))
          const arr = res.data
          const arr2 = ['lineTypeName', 'summary']
          arr.forEach((element, index) => {
            const obj = {
              title: element,
              dataIndex: `date${index + 1}`,
              scopedSlots: { customRender: `date${index + 1}` },
              type: 'inputNumber'
            }
            arr2.push(`date${index + 1}`)
            columns.splice(-3, 0, obj);
          });
          this.columnsAdd = arr2 || []
          this.columns = columns
          this.tableX = 2500 + res.data.length * 100
        } else {
          this.columns = JSON.parse(JSON.stringify(this.columnsOrigin))
        }
      })
    },
    // table的页码控制
    lineTypeListChange (val) {
      if (!val || val.length === 0) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 20
        return
      }
      if (val.length === 1 || val.length === 5) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["10", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 10
      }
      if (val.length === 2 || val.length === 4) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["8", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 8
      }
      if (val.length === 3) {
        this.$refs.dataTable.myPagination.pageSizeOptions = ["9", "20", "50", "100"]
        this.$refs.dataTable.myPagination.pageSize = 9
      }
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === "SCP_MRP_LINE_TYPE_PR_VENDOR") {
          const arr2 = []
          response.rows.forEach(element => {
            if (element.attribute2 === "Y") {
              arr2.push(element.lookupCode)
            }
          });
          this.form.setFieldsValue({
            lineTypeList: arr2
          })
        }
        this[arr] = response.rows
      })
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.onSearch()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select-selection__choice{
  width: 66.47px;
}
.color-red {
  color: red
}
</style>
